angular
  .module('countriesApp')
  .service('CountryModel', [
    'HEADERS_AWS_PATH',
    'SearchParamsService',
    function (HEADERS_AWS_PATH, SearchParams) {
      return class CountryModel {
        constructor(data) {
          this.id = data.id;
          this.name = data.name;
          this.slugAndId = data.slug_and_id;

          this.background_image_url = data.background_image_url;
          if (!data.background_image_url) {
            this.background_image_url = HEADERS_AWS_PATH + data.iso2.toUpperCase() + '.jpg';
          }

          if (data.description) {
            this.description = data.description;
          }

          if (data.page_definition && data.page_definition.sdg) {
            this.sdg = data.page_definition.sdg;
          }

          const details = data.page_definition;

          this.searchParams = {
            'articles': '?' + (
              details.news_search_url || SearchParams.getArticles(this.name)
            ),
            'companies': '?' + (
              details.orgs_search_url || SearchParams.getCompanies(this.name, this.id)
            ),
            'consultants': '?' + (
              details.recruiter_search_url || SearchParams.getConsultants(this.name)
            ),
            'jobs': '?' + (
              details.jobs_search_url || SearchParams.getJobs(this.name)
            )
          };
        }
      };
    }
  ]);
